import { observer } from 'mobx-react'
import React, { useEffect, useState, useMemo } from 'react'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { MyCardDetail, CardLevelModal } from '@cps'
import { IonSlides, IonSlide, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew, modalLayer } from '@utils'
import MyCardItem from '../MyCardItem'
import GetCardItem from '../GetCardItem'
import { findIndex, find } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  cardId?: string;
  source: 'home' | 'my' | 'card';
}

const Entry: React.FC<IProps> = (props: IProps) => {
  const { source, cardId } = props
  const history = useHistoryNew()
  const [detailType, setDetailType] = useState<'open' | 'hide'>('hide')
  const [currCardList, setCurrCardList] = useState<IMemberCardInfo[]>([])
  const { cardList, cardListForMy } = memberMobx
  const { bestDiscountCard } = memberCardMobx
  const getCardDetail = (e: any, info: any) => {
    if (source === 'home') {
      e.stopPropagation()
      modalLayer(MyCardDetail, { cardInfo: info }, 'CardDetail').then((url: any) => {
        history.push(url)
      }, () => { })
    } else if (source === 'my') {
      setDetailType(detailType === 'hide' ? 'open' : 'hide')
    }
  }
  const pageCards = useMemo(() => {
    if (currCardList.length > 0 && cardListForMy.length > 0) {
      return currCardList.map((item: any) => {
        return memberMobx.cardListMap[item.cardId] || item
      })
    } else {
      return memberMobx.cardListForMy
    }
  }, [currCardList, memberMobx.cardListForMy])
  const initOpts = {
    initialSlide: findIndex(pageCards, (item) => `${item.cardId}` === cardId) || 0,
    autoplay: false,
    loop: false,
  }
  useIonViewWillEnter(() => {
    if (memberCardMobx.cardList.length === 0) {
      memberCardMobx.getCardList()
    }
    if (cardList.length === 0 && memberMobx.isLogin) {
      memberMobx.getMemberCards()
    }
    setCurrCardList(cardListForMy)
  }, [])
  useEffect(() => {
    if (!currCardList.length) {
      setCurrCardList(memberMobx.cardListForMy)
    }
  }, [currCardList, memberMobx.cardListForMy])
  useEffect(() => {
    if (cardId && cardListForMy.length && !memberMobx.hasShowLvInfo) {
      memberMobx.updateHasShowLvInfo(true)
      modalLayer(CardLevelModal, { cardInfo: find(cardListForMy, (item) => `${item.cardId}` === cardId) }).then(() => { }, () => { })
    }
  })
  if (memberCardMobx.cardList.length === 0) return <></>
  return (
    <div className='card-panel'>
      {
        cardList.length === 0 && memberCardMobx.cardList.length > 0 &&
          <div className='guide-area'>
            {
              bestDiscountCard && <GetCardItem cardInfo={bestDiscountCard} hasDetail={false}></GetCardItem>
            }
          </div>
      }
      {
        pageCards.length > 0 &&
          <IonSlides className='card-slides' options={initOpts} key={pageCards.map((item: any) => item.addTime).join('_') + cardId}>
            {
              pageCards.map((item: any, index: number) => {
                return (
                  <IonSlide key={index}>
                    <div className='card-area'>
                      <MyCardItem source='home' detailType={detailType} cardInfo={item} onClick={(e: any) => { getCardDetail(e, item) }}></MyCardItem>
                    </div>
                  </IonSlide>)
              })
            }
          </IonSlides>
      }
    </div>
  )
}

export default observer(Entry)
